import { Component } from "react"
import "./CostComparison.css"


class CostComparison extends Component {
    render() {
        return (
            <div className="cost-comparison">
                <div className="cost-comparison-row cost-comparison-bad">
                    <span className="cost-comparison-label">Cost of an uninformed overbid</span>
                    <span className="cost-comparison-value">Up to &euro;20,000</span>
                </div>
                <div className="cost-comparison-row cost-comparison-bad">
                    <span className="cost-comparison-label">Cost of an uninformed listing</span>
                    <span className="cost-comparison-value">Up to &euro;20,000</span>
                </div>
                <div className="cost-comparison-row cost-comparison-neutral">
                    <span className="cost-comparison-label">Estate agent valuation</span>
                    <span className="cost-comparison-value">&euro;150 – &euro;300</span>
                </div>
                <div className="cost-comparison-row cost-comparison-good">
                    <span className="cost-comparison-label">HomeIndex Lifetime Access</span>
                    <span className="cost-comparison-value">&euro;19</span>
                </div>
            </div>
        )
    }
}

export default CostComparison
